import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Box, CssBaseline, useTheme, useMediaQuery, Typography } from '@mui/material'
import Header from './Header.jsx'
import Sidebar from './Sidebar.jsx'

const MainLayout = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile)
  const location = useLocation()

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', overflow: 'hidden' }}>
      <CssBaseline />

      {/* Fixed Header (Full Width) */}
      <Header
        sidebarOpen={sidebarOpen}
        onSidebarToggle={handleSidebarToggle}
        isMobile={isMobile}
      />

      {/* Sidebar - Starts below header visually due to spacer inside */}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isMobile={isMobile}
      />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 3 },
          height: '100vh',
          overflow: 'auto',
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          flexDirection: 'column',
          transition: 'padding 0.3s ease',
        }}
      >
        {/* Spacer for Fixed Header */}
        <Box sx={{ minHeight: 80 }} /> {/* Matches Header height */}

        <Box
          key={location.pathname}
          sx={{
            flexGrow: 1,
            animation: 'fadeIn 0.3s ease-in-out',
            '@keyframes fadeIn': {
              '0%': {
                opacity: 0,
                transform: 'translateY(10px)'
              },
              '100%': {
                opacity: 1,
                transform: 'translateY(0)'
              }
            }
          }}
        >
          <Outlet />
        </Box>
        <Box
          component="footer"
          sx={{
            py: 3,
            textAlign: 'center',
            mt: 'auto',
            borderTop: `1px solid ${theme.palette.divider}`,
            opacity: 0.7
          }}
        >
          <Typography variant="caption" color="textSecondary">
            © {new Date().getFullYear()} Face Recognition System. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default MainLayout